const MAP = {
  // shipment
  Delivered: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
  "In Transit": "bg-blue-50 text-blue-700 ring-blue-600/20",
  Pending: "bg-amber-50 text-amber-700 ring-amber-600/20",
  "Waiting for unloading": "bg-violet-50 text-violet-700 ring-violet-600/20",
  "Vehicle Break down": "bg-red-50 text-red-700 ring-red-600/20",
  Cancelled: "bg-rose-50 text-rose-700 ring-rose-600/20",
  // invoice
  Paid: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
  "Partly Paid": "bg-sky-50 text-sky-700 ring-sky-600/20",
  Unpaid: "bg-amber-50 text-amber-700 ring-amber-600/20",
  Overdue: "bg-rose-50 text-rose-700 ring-rose-600/20",
  // vehicle / driver
  Available: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
  "On Trip": "bg-blue-50 text-blue-700 ring-blue-600/20",
  Maintenance: "bg-amber-50 text-amber-700 ring-amber-600/20",
  "On Leave": "bg-slate-100 text-slate-600 ring-slate-500/20",
};

export default function StatusBadge({ status }) {
  const cls = MAP[status] || "bg-slate-100 text-slate-600 ring-slate-500/20";
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset ${cls}`}
    >
      {status || "—"}
    </span>
  );
}
